import { SaveOrderDto, SaveOrderItemDto } from 'actions/orders/OrdersDtos';
import { Order, OrderItem } from 'types/Order';

export const convertToSaveOrderDto = (order: Order): SaveOrderDto => {
    return {
        uuid: order.uuid,
        marketplace_id: order.marketplaceId,
        customer_id: order.customerId,
        ship_to_customer_id: order.customerId,
        issued_at: order.issuedAt.toISOString(),
        order_items_attributes: order.items.map(item => convertToSaveOrderItemDto(item))
    };
};

export const convertToSaveOrderItemDto = (orderItem: OrderItem): SaveOrderItemDto => {
    return {
        uuid: orderItem.uuid,
        marketplace_id: orderItem.marketplaceId,
        pet_id: orderItem.petId,
        staff_id: orderItem.staffId,
        orderizable_id: orderItem.orderizableId,
        orderizable_type: orderItem.orderizableType,
        quantity: orderItem.quantity,
        amount: orderItem.amount,
        discount_amount: orderItem.discount,
        description: orderItem.description,
        started_at: orderItem.startedAt?.toISOString()
    };
};
